import { MessageSquare, Target, Lightbulb, Rocket, Users, LifeBuoy } from "lucide-react";

const STEPS = [
  { icon: MessageSquare, t: "Discovery", d: "We sit with your designers, PMs and stakeholders to translate game business requirements into clear, testable technical specifications." },
  { icon: Target, t: "Delivery", d: "Iterative builds with the digital twin — architecture, Golang/PHP code, DB schemas, caching and optimized Kubernetes deployments, shipped in sprints." },
  { icon: Lightbulb, t: "Problem solving", d: "When things get hard, we trace root causes, benchmark alternatives and land effective, measured solutions — not guesswork." },
  { icon: Rocket, t: "Optimize & scale", d: "Load testing, query and cache tuning, and autoscaling so your systems stay fast as your player base grows." },
];

const MODELS = [
  { icon: Target, t: "Project-based", d: "A defined scope, timeline and deliverables for a specific system or launch." },
  { icon: Users, t: "Embedded team", d: "The twin plus engineers working inside your squad, sprint by sprint." },
  { icon: LifeBuoy, t: "Retainer & support", d: "Ongoing optimization and 24/24 technical support for live games." },
];

export const Engagements = () => (
  <section id="engagements" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-950/40 border-y border-slate-800/60">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-14">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">Engagements</span>
        <h2 className="mt-3 font-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">How we work with you</h2>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Every engagement is a partnership. We bring a positive, collaborative approach — pairing the digital twin's speed with senior engineering judgement — so your team ships confidently.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((e) => (
          <div key={e.t} data-testid={`engagement-${e.t}`} className="glass rounded-xl border border-slate-800 p-7 hover:border-emerald-500/40 transition-colors">
            <e.icon className="w-6 h-6 text-emerald-400 mb-4" />
            <h3 className="font-display text-lg font-semibold text-slate-100">{e.t}</h3>
            <p className="mt-2 text-sm text-slate-400 leading-relaxed">{e.d}</p>
          </div>
        ))}
      </div>

      <h3 className="mt-14 mb-5 text-sm font-mono uppercase tracking-widest text-slate-500">Engagement models</h3>
      <div className="grid md:grid-cols-3 gap-6">
        {MODELS.map((m) => (
          <div key={m.t} data-testid={`engagement-model-${m.t}`} className="glass rounded-xl border border-slate-800 p-6 flex gap-4 hover:border-emerald-500/40 transition-colors">
            <m.icon className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
            <div>
              <h4 className="text-slate-100 font-medium text-sm">{m.t}</h4>
              <p className="mt-1 text-sm text-slate-400 leading-relaxed">{m.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
